import { Text, Icon, Link, Title } from '@nimbus-ds/components';
import { ExclamationTriangleIcon, ExternalLinkIcon } from '@nimbus-ds/icons';
import { PATH } from 'App/components/Menu/components/utils';
import { useHandleMenuClick } from 'App/hooks';
import { Stack, SubmitButton } from 'commons/components';
import { useTranslationAccount } from 'domains/Account/hooks';
import useReviveStore from 'domains/Account/hooks/useReviveStore';
import { useIsMobileDevice } from 'domains/Auth/hooks';
import { DisabledStoreContentProps } from '../DisabledStoreContent/DisabledStoreContent';

export default function DisabledStore({
  handleRecoverStore,
  logout,
}: Readonly<DisabledStoreContentProps>) {
  const t = useTranslationAccount();
  const isMobileDevice = useIsMobileDevice();
  const { handleClickItem } = useHandleMenuClick();
  const { isLoading } = useReviveStore();
  const handleLogout = isMobileDevice ? handleClickItem : logout;

  return (
    <Stack column align="center" justify="center">
      <ExclamationTriangleIcon size="large" />
      <Title as="h4" textAlign="center">
        {t('canceledStorePage.title')}
      </Title>
      <Text textAlign="center">{t('canceledStorePage.subTitle')}</Text>
      <Stack align="center" justify="center" wrap>
        <SubmitButton
          onClick={handleRecoverStore}
          appearance="primary"
          isLoading={isLoading}
        >
          {t('canceledStorePage.recoverStore')}
          <Icon color="currentColor" source={<ExternalLinkIcon />} />
        </SubmitButton>
        <Link
          onClick={handleLogout}
          appearance="primary"
          as="a"
          textDecoration="none"
          href={isMobileDevice ? PATH.logout : undefined}
        >
          {t('canceledStorePage.logout')}
        </Link>
      </Stack>
    </Stack>
  );
}
